export enum TrackingContext {
	HeaderInteractionContext = "header-interaction-context",
	LobbySelectorInteractionContext = "lobby-selector-interaction-context",
	MenuInteractionContext = "menu-interaction-context",
	BurgerMenuInteractionContext = "burger-menu-interaction-context",
	NavbarInteractionContext = "navbar-interaction-context",
	ProductSelectorInteractionContext = "product-selector-interaction-context",
	CasinoTabInteractionContext = "casino-tab-interaction-context",
	FooterInteractionContext = "footer-interaction-context",
	LanguageSelectorInteractionContext = "language-selector-interaction-context",
	MyAccountInteractionContext = "my-account-interaction-context",
	LoginSupportInteractionContext = "login-support-interaction-context",
	ForgotPasswordInteractionContext = "forgot-password-interaction-context",
	ResetPasswordInteractionContext = "reset-password-interaction-context",
	LoginInteractionContext = "login-interaction-context",
	QuickDepositInteractionContext = "quick-deposit-interaction-context",
	RegulatoryBarInteractionContext = "regulatory-bar-interaction-context",
	BannerInteractionContext = "banner",
	GameFrameInteractionContext = "game-frame-interaction-context",
	CustomerVerificationInteractionContext = "customer-verification-interaction-context",
	AcceptTCInteractionContext = "accept-tc-interaction-context",
	FundsProtectionInteractionContext = "funds-protection-interaction-context",
	DepositLimitCalculatorInteractionContext = "deposit-limit-calculator-interaction-context",
	BottomBarTabInteractionContext = "bottom-bar-game-tab-interaction-context",
	BottomVPVInteractionContext = "bottom-bar-game-virtual-page-view-interaction-context",
	BrandHeaderLogoContext = "brand-header-logo-context",
}

export const enum FooterAction {
	SocialMedia = "SocialMedia",
	SponsorsPartnersAmbassadors = "SponsorsPartnersAmbassadors",
	PaymentsMethods = "PaymentsMethods",
	Regulation = "Regulation",
	ProductLinks = "ProductLinks",
	JurisdictionLogos = "JurisdictionLogos",
	ResponsibleGamingLinks = "ResponsibleGamingLinks",
	Awards = "Awards",
	Licenses = "Licenses",
	OtherClicks = "OtherClicks",
	GameProvider = "GameProvider",
}

export const enum TrackingClickType {
	Link = "LinkClick",
	DropDown = "DropDown",
	Expand = "Expand",
	Select = "Select",
	Deselect = "Deselect",
	MultiSelection = "MultiSelection",
}

export const enum TrackingBurgerMenuAction {
	TopMenu = "Top Burger Menu",
}

export const enum TrackingNavBarAction {
	Logo = "Logo",
	LeftNavigation = "Left Navigation",
	RightNavigation = "Right Navigation",
	Search = "Search",
	Deposit = "Deposit",
	Withdraw = "Withdraw",
	Login = "Login",
	Register = "Open Account",
	DiscardChanges = "Discard Changes",
	SaveChanges = "Save Changes",
	Logout = "Logout",
}

export enum TrackingMyAccountAction {
	Login = "Login",
	Register = "Open Account",
	Deposit = "Deposit",
	Logout = "Logout",
}
